import { render, staticRenderFns } from "./DebtorTracking.vue?vue&type=template&id=5e632117&scoped=true&"
import script from "./DebtorTracking.vue?vue&type=script&lang=ts&"
export * from "./DebtorTracking.vue?vue&type=script&lang=ts&"
import style0 from "./DebtorTracking.vue?vue&type=style&index=0&id=5e632117&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e632117",
  null
  
)

export default component.exports